<section class="bg-color section-margin-top">
    <div class="containers">



        <!-- data-aos="fade-up" data-aos-delay="100"-->
        <div class="title">

            <p>{{ 'Most_SalesTXT' | translate}}</p>
            <h1>{{ 'Most_Sales' | translate }}</h1>
        </div>
        <!-- max-width: 1200px;-->
        <!-- d-none d-md-block-->
        <div class="row carousel-wrapper">
            <ngx-slick-carousel class="carousel"
                                #slickModal="slick-carousel"
                                [config]="slideConfig">
                <div ngxSlickItem *ngFor="let item of dataSourceItems.data" class="slide">


                    <!-- data-aos="flip-right"-->
                    <div class="card d-flex flex-column m-2">
                        <div class="card-main">
                            <!--<div class="discount">9%</div>-->
                            <div class="label2 label-red mt-5" *ngIf="item.activateWebDiscount == true && item.webDiscountFromDate < currentDate && item.webDiscountToDate > currentDate">{{'Sales' | translate }}</div>
                            <div class="label label-green" *ngIf="item.newArrival == true && item.newArrivalFromDate < currentDate && item.newArrivalToDate > currentDate">{{'New' | translate }}</div>

                            <!--<div class="product-container">
                            <div class="p" *ngIf="getNextImage(i)" (click)="onClickNextItem(i)">
                                <img [src]="getNextImage(i)" alt="Product" />
                            </div>
                            <div class="p" *ngIf="getAfterNextImage(i)" (click)="onClickAfterNextItem(i)">
                                <img [src]="getAfterNextImage(i)" alt="Product" />
                            </div>
                            <div class="p" *ngIf="getAfterAfterNextImage(i)" (click)="onClickAfterAfterNextItem(i)">
                                <img [src]="getAfterAfterNextImage(i)" alt="Product" />
                            </div>
                        </div>-->

                            <div class="d-flex" style="justify-content: center;" (click)="onClickItem(item.inItemID)">
                                <img class="image" [src]="apiURL + item.photoPath" alt="Product" />
                            </div>
                            <br />
                            <div class="cart-line">
                                <div class="cart-item ">
                                    <a (click)="addToCart(item)" href="javascript:void(0);" class="icon-design" *ngIf="item.isOutOfStock == false"><i class="fa-solid fa-basket-shopping icon-design"></i>{{'Add_to_Cart' | translate }}</a>

                                </div>
                            </div>
                        </div>

                        <div class="content">
                            <!-- *ngIf="item.isOutOfStock == false"-->
                            <div>
                                <ng-template *ngIf="item.activateWebDiscount == true && item.webDiscountFromDate < currentDate && item.webDiscountToDate > currentDate ; then other_DiscountPrice; else  other_SalePrice">
                                </ng-template>
                                <ng-template #other_SalePrice>
                                    <div style="display: flex; flex-direction: column; justify-content: start; align-items: start;">
                                        <span class="old-price-none"> {{'-'}}</span>
                                        <span class="money">{{ ((item.saleTaxPercentage /100) * item.salesPrice) + item.salesPrice | number:'1.3-3' }} {{'OMR' | translate }} </span>
                                    </div>


                                </ng-template>
                                <ng-template #other_DiscountPrice>
                                    <div style="display: flex; flex-direction: column; justify-content: start; align-items: start;">
                                        <span class="old-price"> {{ ((item.saleTaxPercentage /100) * item.salesPrice) + item.salesPrice | number:'1.3-3' }} {{'OMR' | translate }}</span>
                                        <span class="money">{{ ((item.saleTaxPercentage /100) * item.webDiscountAmount) + item.webDiscountAmount | number:'1.3-3' }} {{'OMR' | translate }} </span>
                                    </div>



                                </ng-template>

                            </div>
                            <div class="mt-2">
                                <a class="item-name" href="javascript:void(0);" (click)="onClickItem(item.inItemID)">
                                    <ng-template *ngIf="SelectedLanguage == 'ar' ; then other_ItemAr  ; else other_ItemEn">
                                    </ng-template>
                                    <ng-template #other_ItemAr>{{ item.webNameAr }}</ng-template>
                                    <ng-template #other_ItemEn>{{ item.webNameEn }}</ng-template>
                                </a>
                            </div>

                            <div class="col-lg-12 col-md-12 mt-2">
                                <button type="button" (click)="addToCart(item)" class="cart-btn">{{'Add_To_Cart' | translate }} <i class='bx  bx-shopping-bag'></i></button>
                            </div>

                        </div>
                    </div>
                </div>
            </ngx-slick-carousel>
        </div>


        <div class="show-more-button-section">
            <p (click)="openItems('most-sales')">{{ 'Show_More' | translate}}</p>
        </div>
        <!--<div class="grid-container d-block d-md-none">
        <div class="row custom-grid">
            <div class="col-lg-3 col-md-4 col-sm-6 col-6 mt-3 g-lg-6 g-md-4 g-sm-2 g-1"
                 *ngFor="let item of displayedItems; let i = index">

                <div class="card d-flex flex-column">



                    <div class="card-main">-->
        <!--<div class="discount">9%</div>-->
        <!--<div class="label2 label-red mt-5" *ngIf="item.activateWebDiscount == true && item.webDiscountFromDate < currentDate && item.webDiscountToDate > currentDate">{{'Sales' | translate }}</div>
    <div class="label label-green" *ngIf="item.newArrival == true && item.newArrivalFromDate < currentDate && item.newArrivalToDate > currentDate">{{'New' | translate }}</div>


    <div class="image-mobile d-flex" (click)="onClickItem(item.inItemID)">
        <img class="card-image" [src]="apiURL + item.photoPath" alt="Product" />
    </div>

    <div class="cart-line">-->
        <!--<div class="cart-item ">
        <a (click)="addToCart(item)" href="javascript:void(0);" class="icon-design" *ngIf="item.isOutOfStock == false"><i class="fa-solid fa-basket-shopping icon-design"></i>{{'Add_to_Cart' | translate }}</a>

    </div>-->
        <!--</div>
    </div>

    <div class="content">-->
        <!-- *ngIf="item.isOutOfStock == false"-->
        <!--<div class="mt-0 pt-0">
                            <ng-template *ngIf="item.activateWebDiscount == true && item.webDiscountFromDate < currentDate && item.webDiscountToDate > currentDate ; then other_DiscountPrice; else  other_SalePrice">
                            </ng-template>
                            <ng-template #other_SalePrice>
                                <div style="display: flex; flex-direction: column; justify-content: start; align-items: start; margin-top: 0;">
                                    <span class="old-price-none"> {{'-'}}</span>
                                    <span class="money">{{ ((item.saleTaxPercentage /100) * item.salesPrice) + item.salesPrice | number:'1.3-3' }} {{'OMR' | translate }} </span>
                                </div>


                            </ng-template>
                            <ng-template #other_DiscountPrice>
                                <div style="display: flex; flex-direction: column; justify-content: start; align-items: start;">
                                    <span class="old-price"> {{ ((item.saleTaxPercentage /100) * item.salesPrice) + item.salesPrice | number:'1.3-3' }} {{'OMR' | translate }}</span>
                                    <span class="money">{{ ((item.saleTaxPercentage /100) * item.webDiscountAmount) + item.webDiscountAmount | number:'1.3-3' }} {{'OMR' | translate }} </span>
                                </div>



                            </ng-template>

                        </div>
                        <div class="mt-1">
                            <a class="item-name-mobile" href="javascript:void(0);" (click)="onClickItem(item.inItemID)">
                                <ng-template *ngIf="SelectedLanguage == 'ar' ; then other_ItemAr  ; else other_ItemEn">
                                </ng-template>
                                <ng-template #other_ItemAr>{{ item.webNameAr }}</ng-template>
                                <ng-template #other_ItemEn>{{ item.webNameEn }}</ng-template>
                            </a>
                        </div>

                        <div class="col-lg-12 col-md-12 mt-1">
                            <button type="button" (click)="addToCart(item)" class="cart-btn">{{'Add_To_Cart' | translate }} <i class='bx  bx-shopping-bag'></i></button>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    </div>

    <br class="d-block d-md-none" />

    <div class="title d-block d-md-none">
        <p (click)="showMore(true)" *ngIf="!isShowingMore">{{ 'Show_More' | translate}}</p>
        <p (click)="showMore(false)" *ngIf="isShowingMore">{{ 'Show_Less' | translate}}</p>
    </div>-->
    </div>
</section>
